import React from "react";

const Forward = (props) => {
  
  React.useEffect(() => {
    window.location.href = "https://theboggler.com"+props.pathname+".html";
  }, []);

  return null;
};

export default Forward;
